import { useContext } from 'react';

import { ProgressBarContext } from '../context/ProgressBarProvider';

export default () => {
  return useContext(ProgressBarContext);
};
